import publicActions from './publicActions'
import userActions from './userActions'
import storeActions from './storeActions'
import orderActions from './orderActions'
import homeActions from './homeActions'
import homePage from './homePage'
import adminActions from './adminActions'
import admin from './admin'
import order from './order'

export default {
  ...publicActions,                     //公共模块修改
  ...userActions,                       //用户基本信息模块修改
  ...storeActions,                      //门店基本信息模块修改
  ...orderActions,                      //订单模块的API接口
  ...homeActions,                       //
  ...adminActions,                      //管理员模块的API接口
  ...admin,                             //管理员模块的API接口
  ...homePage,                          //首页模块的API接口
  ...order,                             //订单模块的API接口

}
